var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8CreditCard64(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162 528 c-7 -7 -12 -34 -12 -60 l0 -48 -58 0 c-32 0 -63 -5 -70 -12 -17 -17 -17 -279 0 -296 17 -17 439 -17 456 0 7 7 12 34 12 60 l0 48 58 0 c32 0 63 5 70 12 17 17 17 279 0 296 -17 17 -439 17 -456 0z m308 -198 c0 -19 -7 -20 -220 -20 -213 0 -220 1 -220 20 0 19 7 20 220 20 213 0 220 -1 220 -20z m-300 -150 c0 -17 -7 -20 -50 -20 -43 0 -50 3 -50 20 0 17 7 20 50 20 43 0 50 -3 50 -20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8CreditCard64);
export default __webpack_public_path__ + "static/media/icons8-credit-card-64.a67268637116a30481da0dd7bc9508ab.svg";
export { ForwardRef as ReactComponent };